// extracted by mini-css-extract-plugin
export default {"sampleContainer":"PokemonSample_sampleContainer__JeMX4"};